(ns minorodata.logs.subs
  (:require [cljs.spec.alpha :as spec]
            [clojure.string :as c-str]
            [re-frame.core :as re-frame]
            [re-posh.core :as re-posh]
            [minorodata.utils :as utils]
            [minorodata.logs.model :refer [log-message]]))

(def system-log-sources
  [{:id "admin"       :name "Administration"         :type :system}
   {:id "VCS"         :name "Version Control System" :type :system}
   {:id "extract"     :name "Extract Updates"        :type :system}
   {:id "file-ingest" :name "File Ingest"            :type :system}
   {:id "job-manager" :name "Transform Executions"   :type :system}
   {:id "scheduler"   :name "Schedule Executions"    :type :system}
   {:id "source"      :name "Source Updates"         :type :system}
   {:id "transform"   :name "Transform Updates"      :type :system}
   {:id "webform"     :name "Webform Updates"        :type :system}])


(defn ->formatted-json-string [data]
  (js/JSON.stringify (clj->js data) nil 2))


(defn format-message [log-message log-sources]
  (let [{:log-message/keys [id message-type message-source created-at message]} log-message
        {:keys [job-id extract-name transform-name model-name task-execution-id]} message
        type-class (case message-type
                     "FAILURE" :type-error
                     "SUCCESS" :type-success
                     "INFO"    :type-info
                     :none)]
    {:id                  id
     :type                message-type
     :message             (when (some? message)
                            (->formatted-json-string message))
     :message-map         message
     :date                created-at
     :type-class          type-class
     :source-name         (if-let [source (utils/find-by-field log-sources :id message-source)]
                            (:name source)
                            message-source)
     :source-id           message-source
     :extr-transform-name (or extract-name transform-name model-name)
     :job-id              job-id
     :job-id-trimmed      (some->> job-id
                                   (take 8)
                                   c-str/join)
     :task-execution-id   task-execution-id
     :task-execution-id-trimmed (some->> task-execution-id
                                         (take 8)
                                         c-str/join)}))


(spec/fdef format-message
  :args (spec/cat :logs-view log-message :log-sources sequential?))


(defn format-connector-sources [used-types {:keys [id name]}]
  {:id   id
   :name (str name " Extract")
   :type (if (contains? used-types id)
           :used-connector
           :unused-connector)})

(defn format-synchro-sources [{:keys [type]}]
  {:id   (str type "-synchronizer")
   :name (str (clojure.string/capitalize type) " Synchronizer")
   :type :used-connector})

(re-frame/reg-sub
 :logs.subs/user-friendly-log-sources
 (fn [_]
   [(re-posh/subscribe [:connections.subs/current-connectors-unfiltered])
    (re-posh/subscribe [:source/pull-many])
    (re-posh/subscribe [:user-synchronizers/prop :user-synchronizers/list])])
 (fn [[connectors sources synchro-sources]]
   (let [users-connector-types     (set (keys (group-by :source/source-type sources)))
         connector-sources         (map (partial format-connector-sources users-connector-types) connectors)
         formatted-synchro-sources (map format-synchro-sources synchro-sources)]
     (concat system-log-sources
             formatted-synchro-sources
             connector-sources))))

(re-frame/reg-sub
 :logs.subs/log-message
 (fn [[_ message-id]]
   [(re-frame/subscribe [:log-message/pull [:log-message/id message-id]])
    (re-frame/subscribe [:logs.subs/user-friendly-log-sources])])
 (fn [[message log-sources]]
   (format-message message log-sources)))

(re-frame/reg-sub
 :logs.misc/config-local-storage-key
 (fn []
   (re-posh/subscribe [:user/prop :user/uid]))
 (fn [uuid]
   (str "logs-config-" uuid)))

(re-frame/reg-sub
 :logs.misc/load-initial-config
 (fn []
   (re-posh/subscribe [:logs.misc/config-local-storage-key]))
 (fn [config-key]
   (js->clj @(re-posh/subscribe [:app.subs/get-local-storage config-key {}])
            :keywordize-keys true)))
